import {
  MODAL_VIEWS,
  useModalAction,
  useModalState,
} from "@/contexts/modal/Context.tsx";
import Popup from "@edusogno/composites/popup";
import EventItemModal from "@/components/agenda/desktop/month/EventItemModal.tsx";
import ConfirmDiplomaRequestModal from "@/components/diploma-requests/ConfirmModal.tsx";
import RequestDiplomaNotificationModal from "@/components/diploma-requests/RequestNotificationModal.tsx";
import ConfirmOneToOneModal from "@/components/one-to-one/ConfirmModal.tsx";
import ConfirmAvailabilitySlotsModal from "@/components/availability/ConfirmSlotsModal.tsx";
import DoExerciseModal from "@/components/exercises/DoExerciseModal.tsx";
import DoExerciseActionModal from "@/components/exercises/DoExerciseActionModal";
import ConfirmMockTestModal from "@/components/exercises/mock-test/ConfirmModal.tsx";
import BookingErrorModal from "@/components/exercises/correction/BookingErrorModal.tsx";
import ConfirmLiveCorrectionBookingModal from "@/components/exercises/correction/ConfirmModal.tsx";
import ExerciseV2Modal from "@/components/exercises/grammar/Desktop/ExerciseV2Modal";
import ConfirmOneToOneFirstSessionModal from "@/components/one-to-one/ConfirmFirstSessionModal";
import ChangeEventModal from "@/components/agenda/change-event/desktop/ChangeEventModal.tsx";
import FeedbackRatingModal from "@/components/agenda/FeedbackRatingModal.tsx";
import AgendaEventFeedbackModal from "@/components/agenda/desktop/month/AgendaEventFeedbackModal.tsx";
import Upselling from "@/pages/agenda/Upselling";
import MaterialsFilterModal from "@/components/materials/MaterialsFilterModal";

function renderModalContent(view: MODAL_VIEWS | undefined, data: unknown) {
  switch (view) {
    case "AGENDA_EVENT_ITEM":
      return <EventItemModal />;
    case "CONFIRM_DIPLOMA_REQUEST_MODAL":
      return <ConfirmDiplomaRequestModal />;
    case "CONFIRM_ONE_TO_ONE_MODAL":
      return <ConfirmOneToOneModal />;
    case "CONFIRM_ONE_TO_ONE_FIRST_SESSION_MODAL":
      return <ConfirmOneToOneFirstSessionModal />;
    // case "CONFIRM_ONE_TO_ONE_SECOND_SESSION_MODAL":
    //   return <ConfirmOneToOneSecondSessionModal />;
    case "REQUEST_DIPLOMA_NOTIFICATION_MODAL":
      return <RequestDiplomaNotificationModal />;
    case "CONFIRM_AVAILABILITY_SLOTS_MODAL":
      return <ConfirmAvailabilitySlotsModal />;
    case "DO_EXERCISE_MODAL":
      return <DoExerciseModal />;
    case "DO_EXERCISE_ACTION_MODAL":
      return <DoExerciseActionModal />;
    case "AGENDA_EVENT_FEEDBACK":
      return <AgendaEventFeedbackModal />;
    case "CONFIRM_MOCK_TEST_MODAL":
      return <ConfirmMockTestModal />;
    case "LIVE_CORRECTION_BOOKING_ERROR_MODAL":
      return <BookingErrorModal />;
    case "CHANGE_EVENT_DESKTOP_MODAL":
      return <ChangeEventModal />;
    case "FEEDBACK_RATING_MODAL":
      return <FeedbackRatingModal />;
    case "CONFIRM_LIVE_CORRECTION_BOOKING_MODAL":
      return <ConfirmLiveCorrectionBookingModal />;
    case "EXERCISE_V2_MODAL": {
      const { score, total, exerciseType } = data as { score: number, total: number, exerciseType: string };
      return <ExerciseV2Modal score={score} total={total} exerciseType={exerciseType}/>;
    }
    case "UPSELLING_MODAL":
      return <Upselling />;
    case "MATERIALS_FILTERS_MODAL":
      return <MaterialsFilterModal />;
    default:
      return null;
  }
}

export default function ModalsContainer() {
  const { view, isOpen, data, headerProps } = useModalState();
  const { closeModal } = useModalAction();

  return (
    <Popup
      open={isOpen}
      onOpenChange={closeModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      {...headerProps}
    >
      <div className="flex flex-col h-full gap-4">
        {renderModalContent(view, data)}
      </div>
    </Popup>
  );
}
